(() => {
  const GIFT_PROPERTY = '_ederra_partner_gift';
  const ROOT = window.Shopify?.routes?.root || '/';

  let busy = false;
  let validationTimer = null;

  function getConfig() {
    const element = document.querySelector('[data-ederra-partner-config]');

    if (!element) {
      return {
        enabled: false,
        code: '',
        giftIds: [],
        successMessage: 'Промокод применён. Подарок добавлен в корзину.',
        buttonText: 'Применить'
      };
    }

    return {
      enabled: element.dataset.enabled === 'true',
      code: String(element.dataset.promoCode || '').trim(),
      giftIds: [
        Number(element.getAttribute('data-gift-1-id') || 0),
        Number(element.getAttribute('data-gift-2-id') || 0)
      ].filter(Boolean),
      successMessage:
        element.dataset.successMessage ||
        'Промокод применён. Подарок добавлен в корзину.',
      buttonText:
        element.dataset.buttonText ||
        'Применить'
    };
  }

  function configIsValid(config) {
    const uniqueGiftIds = [...new Set(config.giftIds.map(Number))];

    return (
      config.enabled &&
      Boolean(config.code) &&
      uniqueGiftIds.length >= 1 &&
      uniqueGiftIds.length <= 2 &&
      uniqueGiftIds.length === config.giftIds.length
    );
  }

  async function getCart() {
    const response = await fetch(`${ROOT}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Не удалось получить корзину.');
    }

    return response.json();
  }

  async function postCart(path, body) {
    const response = await fetch(`${ROOT}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        data.description || data.message || 'Ошибка Shopify.'
      );
    }

    return data;
  }

  function isGift(item) {
    return Boolean(item?.properties?.[GIFT_PROPERTY]);
  }

  function getGiftItems(cart) {
    return Array.isArray(cart?.items) ? cart.items.filter(isGift) : [];
  }

  function giftsAreCorrect(cart, promoCode, giftIds) {
    const gifts = getGiftItems(cart);

    if (!giftIds.length || gifts.length !== giftIds.length) {
      return false;
    }

    return giftIds.every((id) => {
      const item = gifts.find(
        (gift) => Number(gift.variant_id) === Number(id)
      );

      return Boolean(
        item &&
        Number(item.quantity) === 1 &&
        item.properties?.[GIFT_PROPERTY] === promoCode
      );
    });
  }

  function discountIsApplied(cart, promoCode) {
    const expectedCode = String(promoCode || '')
      .trim()
      .toUpperCase();

    const lineDiscountFound = (cart.items || []).some((item) => {
      const allocations = Array.isArray(item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : [];

      return allocations.some((allocation) => {
        const title = String(
          allocation?.discount_application?.title || ''
        )
          .trim()
          .toUpperCase();

        return (
          title === expectedCode &&
          Number(allocation?.amount || 0) > 0
        );
      });
    });

    const cartDiscountFound = (
      Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : []
    ).some((application) => {
      const title = String(application?.title || '')
        .trim()
        .toUpperCase();

      return (
        title === expectedCode &&
        Number(application?.total_allocated_amount || 0) > 0
      );
    });

    return lineDiscountFound || cartDiscountFound;
  }

  function promotionIsApplied(cart, promoCode, giftIds) {
    if (!giftsAreCorrect(cart, promoCode, giftIds)) {
      return false;
    }

    const giftsHavePositivePrice = getGiftItems(cart).every(
      (gift) => Number(gift.final_line_price) > 0
    );

    return (
      giftsHavePositivePrice &&
      discountIsApplied(cart, promoCode)
    );
  }

  async function removeGiftItems() {
    const cart = await getCart();
    const updates = {};

    getGiftItems(cart).forEach((item) => {
      updates[item.key] = 0;
    });

    if (Object.keys(updates).length) {
      await postCart('cart/update.js', { updates });
    }
  }

  async function addGiftItems(promoCode, giftIds) {
    const cart = await getCart();

    if (getGiftItems(cart).length) {
      await removeGiftItems();
    }

    await postCart('cart/add.js', {
      items: giftIds.map((id) => ({
        id,
        quantity: 1,
        properties: {
          [GIFT_PROPERTY]: promoCode
        }
      }))
    });
  }

  async function clearPromotion() {
    const cart = await getCart();
    const updates = {};

    getGiftItems(cart).forEach((item) => {
      updates[item.key] = 0;
    });

    const body = {
      discount: '',
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    if (Object.keys(updates).length) {
      body.updates = updates;
    }

    return postCart('cart/update.js', body);
  }

  function setMessage(text, type = '') {
    document
      .querySelectorAll('[data-ederra-partner-message]')
      .forEach((element) => {
        element.textContent = text;
        element.classList.remove('is-success', 'is-error');

        if (type) {
          element.classList.add(`is-${type}`);
        }
      });
  }

  function setBusy(state) {
    const config = getConfig();

    document
      .querySelectorAll('[data-ederra-partner-apply]')
      .forEach((button) => {
        button.disabled = state;
        button.textContent = state ? 'Применяем...' : config.buttonText;
      });
  }

  function setAppliedUI(applied) {
    const config = getConfig();

    document
      .querySelectorAll('[data-ederra-partner-promo]')
      .forEach((widget) => {
        widget.classList.toggle('is-applied', applied);

        const input = widget.querySelector('[data-ederra-partner-input]');
        const remove = widget.querySelector('[data-ederra-partner-remove]');

        if (input) {
          input.value = applied ? config.code : '';
        }

        if (remove) {
          remove.hidden = !applied;
        }
      });
  }

  function refreshDrawer(cart) {
    const drawer = document.querySelector('cart-drawer');

    if (
      drawer &&
      cart.sections?.['cart-drawer'] &&
      typeof drawer.renderContents === 'function'
    ) {
      drawer.renderContents(cart);
    }
  }

  async function applyPromotion(enteredCode) {
    if (busy) return;

    const config = getConfig();

    if (!config.enabled) {
      setMessage('Акция сейчас отключена.', 'error');
      return;
    }

    if (!config.code) {
      setMessage('Не указан промокод Shopify.', 'error');
      return;
    }

    if (!configIsValid(config)) {
      setMessage('Проверьте Variant ID подарка в настройках темы.', 'error');
      return;
    }

    const typed = String(enteredCode || '').trim().toUpperCase();
    const configured = config.code.trim().toUpperCase();

    if (!typed) {
      setMessage('Введите промокод.', 'error');
      return;
    }

    if (typed !== configured) {
      setMessage('Неверный промокод.', 'error');
      return;
    }

    busy = true;
    setBusy(true);
    setMessage('');

    try {
      await addGiftItems(config.code, config.giftIds);

      let cart = await postCart('cart/update.js', {
        discount: config.code,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      });

      if (!promotionIsApplied(cart, config.code, config.giftIds)) {
        cart = await clearPromotion();
        refreshDrawer(cart);

        setTimeout(() => {
          setAppliedUI(false);
          setMessage(
            'Промокод недействителен или условия акции не выполнены.',
            'error'
          );
        }, 100);

        return;
      }

      refreshDrawer(cart);

      setTimeout(() => {
        setAppliedUI(true);
        setMessage(config.successMessage, 'success');
      }, 100);

    } catch (error) {
      console.error('EDERRA promo:', error);

      try {
        const cart = await clearPromotion();
        refreshDrawer(cart);
      } catch (_) {}

      setAppliedUI(false);
      setMessage('Не удалось применить промокод.', 'error');

    } finally {
      busy = false;
      setBusy(false);
    }
  }

  async function removePromotion() {
    if (busy) return;

    busy = true;
    setBusy(true);

    try {
      const cart = await clearPromotion();
      refreshDrawer(cart);

      setTimeout(() => {
        setAppliedUI(false);
        setMessage('');
      }, 100);

    } catch (error) {
      console.error('EDERRA promo remove:', error);
      setMessage('Не удалось убрать промокод.', 'error');

    } finally {
      busy = false;
      setBusy(false);
    }
  }

  async function validateActivePromotion() {
    if (busy) return;

    const config = getConfig();

    try {
      let cart = await getCart();
      const gifts = getGiftItems(cart);

      if (!gifts.length) {
        return;
      }

      busy = true;

      if (!configIsValid(config)) {
        const cleaned = await clearPromotion();
        refreshDrawer(cleaned);
        return;
      }

      cart = await postCart('cart/update.js', {
        discount: config.code,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      });

      if (!promotionIsApplied(cart, config.code, config.giftIds)) {
        const cleaned = await clearPromotion();
        refreshDrawer(cleaned);

        setTimeout(() => {
          setAppliedUI(false);
          setMessage('Условия акции больше не выполняются.', 'error');
        }, 100);
      }

    } catch (error) {
      console.error('EDERRA promo validation:', error);

    } finally {
      busy = false;
      setBusy(false);
    }
  }

  function scheduleValidation() {
    clearTimeout(validationTimer);
    validationTimer = setTimeout(validateActivePromotion, 1000);
  }

  document.addEventListener('click', (event) => {
    const apply = event.target.closest('[data-ederra-partner-apply]');

    if (apply) {
      const widget = apply.closest('[data-ederra-partner-promo]');
      const input = widget?.querySelector('[data-ederra-partner-input]');

      applyPromotion(input?.value || '');
      return;
    }

    const remove = event.target.closest('[data-ederra-partner-remove]');

    if (remove) {
      removePromotion();
      return;
    }

    if (
      event.target.closest('cart-remove-button') ||
      event.target.closest('.button-cart-item-remove')
    ) {
      scheduleValidation();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Enter' &&
      event.target.matches('[data-ederra-partner-input]')
    ) {
      event.preventDefault();
      applyPromotion(event.target.value);
    }
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('.quantity__input') ||
      event.target.matches('[name="updates[]"]')
    ) {
      scheduleValidation();
    }
  });

  async function initialize() {
    const config = getConfig();

    try {
      const cart = await getCart();
      const gifts = getGiftItems(cart);

      if (!config.enabled || !configIsValid(config)) {
        if (gifts.length) {
          await clearPromotion();
        }
        return;
      }

      if (promotionIsApplied(cart, config.code, config.giftIds)) {
        setAppliedUI(true);
        setMessage(config.successMessage, 'success');
      } else if (gifts.length) {
        await clearPromotion();
        setAppliedUI(false);
        setMessage('');
      }

    } catch (error) {
      console.error('EDERRA promo init:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
